"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateBundleDetails = exports.validateBundleComposition = exports.failingBundleRequirements = exports.bundleSlotFor = exports.BundleSlots = exports.AccessDomains = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _entity = require("./entity");
// What may go into a bundle (Pacchetto) — #1769. ONE implementation, used by the YouDeal builder
// (its "Requisiti" panel) and by api/proxy (createMembershipBundle / updateBundle), so the screen
// and the API can never disagree.

// memberships.domain of an access membership. NULL is treated as gym (migration 012).
var AccessDomains = exports.AccessDomains = {
  gym: 'gym',
  video: 'video',
  training: 'training'
};

// The builder's slots. A bundle holds at most one item per slot.
var BundleSlots = exports.BundleSlots = {
  service: 'service',
  courseOrEvent: 'class',
  bookingRule: 'booking',
  gym: 'gym',
  video: 'video',
  training: 'training',
  invitationFlow: 'invitation'
};

// Items that can stand alone and that Video, Training and the invitation flow need beside them.
var BUNDLE_ANCHOR_SLOTS = [BundleSlots.service, BundleSlots.courseOrEvent, BundleSlots.gym];

// Which slot an item goes in, or null when it fits none (e.g. the old `video`/`workout` membership
// types). item: { kind: 'membership', membershipType, domain } | { kind: 'invitationFlow' }.
var bundleSlotFor = exports.bundleSlotFor = function bundleSlotFor(item) {
  if ((item === null || item === void 0 ? void 0 : item.kind) === 'invitationFlow') {
    return BundleSlots.invitationFlow;
  }
  switch (item === null || item === void 0 ? void 0 : item.membershipType) {
    case _entity.MembershipTypes.service:
      return BundleSlots.service;
    case _entity.MembershipTypes.courseOrEvent:
      return BundleSlots.courseOrEvent;
    case _entity.MembershipTypes.subscription:
      return BundleSlots.bookingRule;
    case _entity.MembershipTypes.access:
      if (!item.domain || item.domain === AccessDomains.gym) {
        return BundleSlots.gym;
      }
      if (item.domain === AccessDomains.video) {
        return BundleSlots.video;
      }
      if (item.domain === AccessDomains.training) {
        return BundleSlots.training;
      }
      return null;
    default:
      return null;
  }
};

// The slots a booking rule applies through: reservation rules act when a service is booked,
// subscription rules on a class/event sign-up (ReservationsAPI / SubscriptionsAPI). The legacy
// cancelPeriod (no longer offered, not enforced) is satisfied by either.
var RULE_NEEDS = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _entity.MembershipRuleTypes.reservationLimit, {
  key: 'ruleNeedsService',
  slots: [BundleSlots.service]
}), _entity.MembershipRuleTypes.cancelReservationLimit, {
  key: 'ruleNeedsService',
  slots: [BundleSlots.service]
}), _entity.MembershipRuleTypes.subscriptionLimit, {
  key: 'ruleNeedsClass',
  slots: [BundleSlots.courseOrEvent]
}), _entity.MembershipRuleTypes.cancelSubscriptionLimit, {
  key: 'ruleNeedsClass',
  slots: [BundleSlots.courseOrEvent]
}), _entity.MembershipRuleTypes.cancelPeriod, {
  key: 'ruleNeedsServiceOrClass',
  slots: [BundleSlots.service, BundleSlots.courseOrEvent]
});

// The composition requirements, one entry per requirement — every one is always present (ok or
// not), so a panel can list them all, not only the first failure:
//   [{ key, ok, slots, params }]
// `slots`: the empty slots that would resolve a failing entry (the builder outlines them).
// items: [{ kind: 'membership', id, name, membershipType, domain, rules: [{ id, name, type }] }
//         | { kind: 'invitationFlow', id, name }]
var validateBundleComposition = exports.validateBundleComposition = function validateBundleComposition() {
  var _bySlot$BundleSlots$b;
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var bySlot = {};
  var misfits = [];
  items.forEach(function (item) {
    var slot = bundleSlotFor(item);
    if (!slot || bySlot[slot]) {
      misfits.push(item);
    } else {
      bySlot[slot] = item;
    }
  });
  var has = function has(slot) {
    return !!bySlot[slot];
  };
  var hasAnchor = BUNDLE_ANCHOR_SLOTS.some(has);
  var needsAnchor = [BundleSlots.video, BundleSlots.training, BundleSlots.invitationFlow].some(has);
  var entries = [{
    key: 'atLeastOneItem',
    ok: items.length > 0,
    slots: BUNDLE_ANCHOR_SLOTS,
    params: {}
  }, {
    key: 'oneItemPerSlot',
    ok: misfits.length === 0,
    slots: [],
    params: {
      items: misfits.map(function (m) {
        return {
          id: m.id,
          name: m.name
        };
      })
    }
  }, {
    key: 'anchorRequired',
    ok: !needsAnchor || hasAnchor,
    slots: BUNDLE_ANCHOR_SLOTS,
    params: {}
  }];
  var bookingRules = ((_bySlot$BundleSlots$b = bySlot[BundleSlots.bookingRule]) === null || _bySlot$BundleSlots$b === void 0 ? void 0 : _bySlot$BundleSlots$b.rules) || [];
  bookingRules.forEach(function (rule) {
    var need = RULE_NEEDS[rule.type];
    if (need) {
      entries.push({
        key: need.key,
        ok: need.slots.some(has),
        slots: need.slots,
        params: {
          ruleId: rule.id,
          ruleName: rule.name
        }
      });
    }
  });

  // Access rules (accessLimit, accessPeriod, …) belong to access memberships only.
  var accessRules = bookingRules.filter(function (rule) {
    return (0, _entity.getMembershipRuleFamily)(rule.type) === _entity.MembershipRuleFamilies.access;
  });
  entries.push({
    key: 'accessRulesOnAccessOnly',
    ok: accessRules.length === 0,
    slots: [BundleSlots.bookingRule],
    params: {
      rules: accessRules.map(function (r) {
        return {
          id: r.id,
          name: r.name
        };
      })
    }
  });
  return entries;
};

// The details every bundle needs: a name, a group, a price (a number, may be 0), a duration > 0.
var validateBundleDetails = exports.validateBundleDetails = function validateBundleDetails() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    name = _ref.name,
    groupId = _ref.groupId,
    price = _ref.price,
    duration = _ref.duration;
  return [{
    key: 'name',
    ok: typeof name === 'string' && name.trim().length > 0
  }, {
    key: 'group',
    ok: groupId !== null && groupId !== undefined && groupId !== ''
  }, {
    key: 'price',
    ok: price !== null && price !== undefined && price !== '' && Number.isFinite(+price) && +price >= 0
  }, {
    key: 'duration',
    ok: Number.isFinite(+duration) && +duration > 0
  }];
};

// The keys of the failing entries — what the API reports in its InputValidation error.
var failingBundleRequirements = exports.failingBundleRequirements = function failingBundleRequirements(entries) {
  return (0, _toConsumableArray2["default"])(new Set(entries.filter(function (e) {
    return !e.ok;
  }).map(function (e) {
    return e.key;
  })));
};
